export const VISUAL = {
  background: 0x02040a,
  front: 0x35eaff,
  back: 0xff405c,
  spanning: 0xc777ff,
  rearBlockOpacity: 0.5,
  warpParticleScale: 3,
  layerDepth: 1.9,
  cellSize: 0.92,
  cellGap: 0.08,
  targetDiameter: 18.5,
  numViews: 45,
  tileHeight: 512,
  depthiness: 0.7,
  testDepth: 1.5,
  filterMode: 0,
  cameraPitch: Math.PI / 6,
  gameOverSeconds: 6,
} as const;
